export const setWorkOrderAutocompleteList = (state, payload) => {
    state.autocomplete_list = payload
}

export const resetWorkOrderAutocompleteList = state => {
    state.autocomplete_list = []
}

export const setSingleWorkOrderData = (state, payload) => {

    if(payload.wo_index !== undefined) {
        let workOrderHistory = JSON.parse(JSON.stringify(state.props[payload.wo_index].work_order_history))
        state.props[payload.wo_index].special_instruction = payload.response[0].special_instruction
        state.props[payload.wo_index].internal_remarks = payload.response[0].internal_remarks
        state.props[payload.wo_index].customer_measurement_profile = payload.response[0].customer_measurement_profile
        state.props[payload.wo_index].style_list = payload.response[0].style_list
        state.props[payload.wo_index].process_list = payload.response[0].process_list
        state.props[payload.wo_index].work_order_history = workOrderHistory
    } else {
        if(payload.shortcut) {
            payload.response.forEach(element => {
                element.trial_form.take_trial = element.trial_history.length>0
            })            
        }
        state.props = payload.response
    }
    
}

export const setWorkOrderLoad = (state, payload) => {
    let list = state.props
    let listIndex = list.findIndex(t => t.sale_item_id == payload.sale_item_id && t.tailoring_item_id == payload.tailoring_item_id)

    let distinctDates = payload.list.filter((thing, index, self) =>
        index === self.findIndex((t) => (t.appointment_date === thing.appointment_date))
    )

    let workOrderLoad = []
    distinctDates.forEach(element => {
        workOrderLoad.push({
            appointment_date: element.appointment_date,
            appointment_date_changed: element.appointment_date_changed,
            delivery: payload.list.filter(t => t.appointment_date == element.appointment_date && t.appointment_type === 0).length,
            trial: payload.list.filter(t => t.appointment_date == element.appointment_date && t.appointment_type === 1).length
        })
    })

    state.props[listIndex].work_order_load = workOrderLoad
}

export const resetSingleWorkOrderData = state => {
    state.props = []
}

export const setLazyLoadWorkOrder = (state, payload) => {
    const workOrderIndex = state.props
        .findIndex(t => t.sale_item_id === payload.previousPayload.sale_item_id 
                && t.sale_item_sub_id === payload.previousPayload.sale_item_sub_id)
    
    if(workOrderIndex>=0) {
        if(payload.activeTab === '2') {
            state.props[workOrderIndex].customer_measurement_profile = payload.response
            state.props[workOrderIndex].measurement_loading = false
                console.log(workOrderIndex, state.props[workOrderIndex].measurement_loading)
        } else if(payload.activeTab === '3') {
            state.props[workOrderIndex].style_list = payload.response
        } else if(payload.activeTab === '4') {
            state.props[workOrderIndex].process_list = payload.response
        }
    }
}




// WEBPACK FOOTER //
// ./src/store/modules/workOrder/mutations.js